module.exports = __webpack_public_path__ + "static/media/planner-lite-icon.7da64981.svg";